import { initState } from "./state";
import { Types } from "./types";

export const reducer = (state = initState, action) => {
  switch (action.type) {
    case Types.SET_ALERT:
      return {
        ...state,
        global: {
          ...state.global,
          alert: action.payload
        }
      }; 
    case Types.DEAL_PRICE:
      return {
        ...state,
        deal: {
          ...state.deal,
          price: action.payload
        }
      }; 
    case Types.STAKE_AMOUNT:
      return {
        ...state,
        stake: {
          ...state.stake,
          amount: action.payload
        }
      }; 
    case Types.DEAL_NAME:
      return {
        ...state,
        deal: {
          ...state.deal,
          name: action.payload
        }
      }; 
    case Types.DEAL_DESC:
      return {
        ...state,
        deal: {
          ...state.deal,
          desc: action.payload
        }
      }; 
    case Types.DEAL_WEBSITE_URL:
      return {
        ...state,
        deal: {
          ...state.deal,
          websiteUrl: action.payload
        }
      }; 
    case Types.DEAL_LEAD_INVESTOR:
      return {
        ...state,
        deal: {
          ...state.deal,
          leadInvestor: action.payload
        }
      }; 
    case Types.DEAL_CRYPTO:
      return {
        ...state,
        deal: {
          ...state.deal,
          crypto: action.payload
        }
      }; 
    case Types.DEAL_PRESAIL_AMOUNT:
      return {
        ...state,
        deal: {
          ...state.deal,
          presailAmount: action.payload
        }
      }; 
    case Types.DEAL_MINSALE_AMOUNT:
      return {
        ...state,
        deal: {
          ...state.deal,
          minsaleAmount: action.payload
        }
      }; 
    case Types.DEAL_MAXSALE_AMOUNT:
      return {
        ...state,
        deal: {
          ...state.deal,
          maxsaleAmount: action.payload
        }
      }; 
    case Types.DEAL_START_BONUS:
      return {
        ...state,
        deal: {
          ...state.deal,
          startBonus: action.payload
        }
      }; 
    case Types.DEAL_END_BONUS:
      return {
        ...state,
        deal: {
          ...state.deal,
          endBonus: action.payload
        }
      }; 
    case Types.DEAL_LOGO:
      return {
        ...state,
        deal: {
          ...state.deal,
          logo: action.payload
        }
      }; 
    case Types.DEAL_OFFER_PERIOD:
      return {
        ...state,
        deal: {
          ...state.deal,
          offerPeriod: action.payload
        }
      }; 
    case Types.DEAL_OFFER_TERMS:
      return {
        ...state,
        deal: {
          ...state.deal,
          offerTerms: action.payload
        }
      }; 
    case Types.DEAL_MIN_STAKE_AMOUNT:
      return {
        ...state,
        deal: {
          ...state.deal,
          minStakeAmount: action.payload
        }
      }; 
    case Types.DEAL_MAX_STAKE_AMOUNT:
      return {
        ...state,
        deal: {
          ...state.deal,
          maxStakeAmount: action.payload
        }
      }; 

    default:
      break;
  }

  return state;
}